"use client"

import { useCallback, useContext, useEffect, useState } from "react"
import { AppointmentContext } from "../context/AppointmentContext"
import { toast, ToastContainer } from "react-toastify"
import config from "../config"
import Footer from "../shared/Footer"
import Header from "../shared/Header"
import { useNavigate } from "react-router-dom"
import OpdBillPdf from "../shared/OpdBillPdf"
import { pdf } from "@react-pdf/renderer"
import JsBarcode from "jsbarcode"
import { PulseLoader } from "react-spinners"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import { AnimatePresence, motion } from "framer-motion"
import FullPageLoader from "../shared/Loader"
import Swal from "sweetalert2"
import MoneyReceiptPDF from "./MoneyReceiptPDF";
import { saveAs } from "file-saver";
import { TiDocumentText } from "react-icons/ti";
import { generateOneTimeToken } from "../utils/authToken"
// Import this for FullCalendar styling

const toISODate = (dateStr) => {
  // from DD-MM-YYYY to YYYY-MM-DD
  const [day, month, year] = dateStr.split("-")
  return `${year}-${month}-${day}`
}

export default function AllStatus() {
  const { hospitalName } = useContext(AppointmentContext)
  const [appointments, setAppointments] = useState([])
  const [loading, setLoading] = useState(false)
  const [fetchError, setFetchError] = useState("")
  const [showModal, setShowModal] = useState(false)
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null)
  const [openDropdownId, setOpenDropdownId] = useState(null)
  const [bookingAmountInfo, setBookingAmountInfo] = useState(null)
  const [selectedOrder, setSelectedOrder] = useState(null)
  const [payNowLoadingId, setPayNowLoadingId] = useState(null)
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const [isDoctorListOpen, setIsDoctorListOpen] = useState(false)
  const [calendarLoading, setCalendarLoading] = useState(false)
  // For Calendar Modal & Doctor Modal
  const [events, setEvents] = useState([])
  const [datesWithDoctors, setDatesWithDoctors] = useState(new Set())
  const [datesWithoutDoctors, setDatesWithoutDoctors] = useState(new Set())
  const [futureDates, setFutureDates] = useState([])
  const [naDates, setNaDates] = useState([])
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [downloadingId, setDownloadingId] = useState(null);

  // For doctor details below calendar after user clicks a date
  const [modalData, setModalData] = useState(null)
  const [modalLoading, setModalLoading] = useState(false)
  const [selectedBookingNo, setSelectedBookingNo] = useState(null)
  const [selectedDoctorCode, setSelectedDoctorCode] = useState(null)
  const [selectedDepartment, setSelectedDepartment] = useState("")
  const [tableData, setTableData] = useState([])
  const [isPaying, setIsPaying] = useState(false)

  const navigate = useNavigate()

  // Fetch all appointments
  const handleDownloadApplication = async (challanno) => {
    try {

      setDownloadingId(challanno);
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/PrintPaymentInformation`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
          body: JSON.stringify({ ORDER_ID: challanno }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch data");

      const data = await response.json();

      const blob = await pdf(
        <MoneyReceiptPDF data={data.data.print_details[0]} />
      ).toBlob();

      saveAs(blob, "money_receipt.pdf");
    } catch (err) {
      console.error(err);
    } finally {
      setDownloadingId(null);
    }
  };
 const canCancelAppointment = (date, time) => {
  if (!date || !time) return false;

  // Convert "09-02-2026" → parts
  const [day, month, year] = date.split("-");

  // Convert "07:00 PM" → 24-hour
  let [hours, minutes] = time.split(/[: ]/); // ["07","00","PM"]
  const period = time.split(" ")[1]; // AM or PM

  hours = parseInt(hours, 10);

  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  // Create valid JS date
  const appointmentDateTime = new Date(
    year,
    month - 1,
    day,
    hours,
    parseInt(minutes, 10)
  );

  const now = new Date();

  const diffInHours = (appointmentDateTime - now) / (1000 * 60 * 60);

  return diffInHours >= 24;
};

  const fetchAppointments = useCallback(async () => {
    setLoading(true)
    setFetchError("")

    try {
      const type = hospitalName === "hazra" ? "hazra" : "newtown"
      const contact = sessionStorage.getItem("loginMobile")

      if (!contact) {
        navigate("/login")
        return
      }

      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/VIEW_FOR_ONLINE_BOOKING_PATIENT`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
        body: JSON.stringify({ TYPE: type, CONTACT: contact, STATUS: "ALL" }),
      })

      if (!response.ok) throw new Error(`Network error: ${response.status}`)

      const respJson = await response.json()
      const apptList = respJson?.data?.appointment_details

      if (respJson.status === 200 && Array.isArray(apptList)) {
        const mappedAppointments = apptList.map((item) => {
          const [datePart = "", ...timeParts] = (item.DATE || "").split(" ")
          const timePart = timeParts.join(" ").trim()

          return {
            id: item.BOOKING_NO || "",
            date: datePart,
            time: timePart,
            doctor: item.DOCTOR_NAME || "",
            status: (item.STATUS || "PENDING").toUpperCase(),
            patient: item.PT_NAME || "",
            amount: item.AMOUNT || "",
            contact: item.PT_CONTACT || "",
            department: item.ADMISSION_DEPARTMENT_NAME || "",
            pt_code: item.PT_CODE || "",
            dt_code: item.DEPARTMENT_CODE || "",
            doctor_code: item.DOCTOR_CODE || "",
            online_payment_status: item.ONLINE_PAYMENT_STATUS || ""
          }
        })

        setAppointments(mappedAppointments)
        setTableData(respJson?.data?.appointment_details)
      } else {
        setAppointments([])
        setFetchError("No appointments found.")
      }
    } catch (err) {
      console.error("Fetch error:", err)
      setFetchError("Unable to fetch appointments.")
    } finally {
      setLoading(false)
    }
  }, [hospitalName, navigate])

  useEffect(() => {
    fetchAppointments()
  }, [fetchAppointments])

  const handleDelete = async () => {
    if (!selectedAppointmentId) return

    try {
      // Make the API call
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        `${config.API_BASE_URL}/UPDATE_ONLINE_BOOKING_STATUS_TO_HOLD_FOR_REFUND_OR_CANCELLED`,
        {
          method: "POST", // or 'PUT' if your API requires it
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": tokeng,
          },
          body: JSON.stringify({
            BOOKINGID: selectedAppointmentId,
            TYPE: sessionStorage.getItem("selectedHospital"),
          }),
        },
      )

      if (!response.ok) {
        throw new Error("Failed to update booking status")
      }

      // If API succeeds, update UI state
      setAppointments((prev) => prev.filter((appt) => appt.id !== selectedAppointmentId))
      setSelectedAppointmentId(null)
      setShowModal(false)
      Swal.fire({
        icon: "success",
        title: "Appointment cancelled.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      })

      setTimeout(() => {
        navigate("/cancel-status")
      }, 3000)
    } catch (error) {
      console.error("Error cancelling appointment:", error)
      toast.error("Failed to cancel appointment. Please try again.")
    }
  }

  const toggleDropdown = (appointmentId) => {
    setOpenDropdownId(openDropdownId === appointmentId ? null : appointmentId)
  }

  const closeAllDropdowns = () => {
    setOpenDropdownId(null)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll("[data-dropdown]")
      let insideDropdown = false
      dropdowns.forEach((dropdown) => {
        if (dropdown.contains(event.target)) insideDropdown = true
      })
      if (!insideDropdown) closeAllDropdowns()
    }

    document.addEventListener("click", handleClickOutside)
    return () => {
      document.removeEventListener("click", handleClickOutside)
    }
  }, [])

  const fetchOpdBillByPtCode = async (pt_code) => {
    try {
      const effectivePtCode = pt_code || ""

      const tokeng = generateOneTimeToken();
      const res = await fetch(`${config.API_BASE_URL}/FetchslipDataOfOPD`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
        body: JSON.stringify({ pT_CODE: effectivePtCode, type: "newtown" }),
      })

      if (!res.ok) {
        toast.error("Failed to fetch OPD bill data.")
        return null
      }

      const result = await res.json()

      if (result.status === 200 && result.data) {
        return result.data
      } else {
        toast.error("Bill data not available.")
        return null
      }
    } catch (error) {
      console.error("Error fetching OPD bill:", error)
      toast.error("Something went wrong while fetching bill data.")
      return null
    }
  }

  const generateBarcodeBase64 = (text) => {
    const canvas = document.createElement("canvas")
    JsBarcode(canvas, text, {
      format: "CODE128",
      displayValue: true,
      fontSize: 12,
      width: 2,
      height: 40,
      margin: 0,
    })
    return canvas.toDataURL("image/png")
  }

  const handlePrintOpdBill = async (pt_code) => {
    setLoading(true)
    closeAllDropdowns()

    try {
      const billData = await fetchOpdBillByPtCode(pt_code)
      if (!billData) return

      const billNo = "CNCIONB00103"
      if (!billNo || typeof billNo !== "string" || billNo.trim() === "") {
        toast.error("Invalid or missing bill number for barcode.")
        return
      }

      let barcodeImage = null
      try {
        barcodeImage = generateBarcodeBase64(billNo)
      } catch (error) {
        console.error("Barcode generation error:", error)
        toast.error("Failed to generate barcode.")
        return
      }

      try {
        const blob = await pdf(<OpdBillPdf data={billData} barcodeImage={barcodeImage} />).toBlob()
        const blobUrl = URL.createObjectURL(blob)
        window.open(blobUrl, "_blank")
      } catch (error) {
        console.error("Error generating PDF:", error)
        toast.error("Failed to generate PDF.")
      }
    } catch (error) {
      console.error("Unexpected error in handlePrintOpdBill:", error)
      toast.error("Something went wrong.")
    } finally {
      setLoading(false)
    }
  }

  const closePayNowModal = () => {
    setSelectedOrder(null)
    setBookingAmountInfo(null)
  }

  const handleProceedToPayment = () => {
    if (!bookingAmountInfo) {
      toast.error("Booking information is missing.")
      return
    }
    try {
      setIsPaying(true)

      const orderId = bookingAmountInfo?.ORDER_ID || "N/A"
      const customerId = sessionStorage.getItem("loginMobile") || "UNKNOWN"
      const transactionAmount = bookingAmountInfo?.REGISTRATION_AMT || "0"
      const paddingZeroDate = () => {
        const dt = new Date()
        const day = String(dt.getDate()).padStart(2, "0")
        const month = String(dt.getMonth() + 1).padStart(2, "0")
        const year = dt.getFullYear()
        return `${day}-${month}-${year}`
      }
      const requestDateTime = paddingZeroDate()

      const isProd = bookingAmountInfo?.DEVELOPMENT_MODE !== "YES"

      const url = isProd ? config.PAYMENT_LINK_PRODUCTION : config.PAYMENT_LINK_DEV
      const responseUrl = isProd ? config.PAYMENT_RESPONSE_URL_PRODUCTION : config.PAYMENT_RESPONSE_URL_DEV
      const serviceId = isProd ? config.SERVICE_ID_PRODUCTION : config.SERVICE_ID_DEV
      const merchantId = isProd ? config.MERCHANT_ID_PRODUCTION : config.MERCHANT_ID_DEV
      const secretKey = isProd ? config.SECRET_KEY_PRODUCTION : config.SECRET_KEY_DEV

      const currency = config.REACT_APP_CURRENCY || "INR"
      const messageType = config.MESSAGE_TYPE || "AR"
      const additionalFields = ["test1", "test2", "test3", "test4", "test5"]

      const formattedAmount = Number(transactionAmount).toFixed(2)

      const msg = [
        messageType,
        merchantId,
        serviceId,
        orderId,
        customerId,
        formattedAmount,
        currency,
        requestDateTime,
        responseUrl,
        responseUrl,
        ...additionalFields,
      ].join("|")

      const checksum = generateOneTimeToken(msg, secretKey)

      const form = document.createElement("form")
      form.name = "URL"
      form.method = "POST"
      form.enctype = "multipart/form-data"
      form.action = url
      form.style.display = "none"

      const appendHidden = (name, value) => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = name
        input.value = value
        form.appendChild(input)
      }

      appendHidden("messageType", messageType)
      appendHidden("merchantId", merchantId)
      appendHidden("serviceId", serviceId)
      appendHidden("currencyCode", currency)
      appendHidden("successUrl", responseUrl)
      appendHidden("failUrl", responseUrl)
      appendHidden("orderId", orderId)
      appendHidden("customerId", customerId)
      appendHidden("transactionAmount", formattedAmount)
      appendHidden("requestDateTime", requestDateTime)

      additionalFields.forEach((field, i) => {
        appendHidden(`additionalField${i + 1}`, field)
      })
      appendHidden("checksum", checksum)
      document.body.appendChild(form)
      setTimeout(() => {
        form.submit()
      }, 80)
      document.body.removeChild(form)
    } catch (err) {
      console.error(err)
      setIsPaying(false)
      toast.error("Payment initiation failed")
    }
  }

  const getStatusColor = (status) => {
    const colors = {
      PENDING: "bg-red-500 text-white",
      CONFIRM: "bg-green-500 text-white",
      HOLD_FOR_REFUND: "bg-red-100 text-red-800 border-red-200",
      RESCHEDULE: "bg-yellow-600 text-black  font-bold",
    }
    return colors[status] || "bg-gray-100 text-gray-800 border-gray-200"
  }

  // CALENDAR DATA/LOGIC

  // Runs when isCalendarOpen becomes true

  // React hook to call the schedule loader when calendar is opened
  useEffect(() => {
    if (isCalendarOpen) {
      getDoctorWeeklySchedule()
      setModalData(null)
      setModalLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCalendarOpen])

  // ASYNC handleDateClick as user requested
  const handleDateClick = async (info) => {
    const dateStr = info.dateStr.trim(); // YYYY-MM-DD from FullCalendar
    const isDisabled = info.dayEl.classList.contains("fc-disabled-date");
    const hasNoDoctors = info.dayEl.classList.contains("fc-no-doctors");

    setModalData(null);
    setIsDoctorListOpen(false);
    // if (isDisabled || hasNoDoctors || naDates.includes(dateStr) || datesWithoutDoctors.has(dateStr)) {
    if (hasNoDoctors) {
      toast.error("No doctors are available on this date!", {
        autoClose: 2000,
        position: "top-center",
      });
      return;
    }

    if (futureDates.includes(dateStr) && datesWithDoctors.has(dateStr)) {
      sessionStorage.setItem("SELECTED_DATE", dateStr);
      sessionStorage.removeItem("SELECTED_TIME");
      sessionStorage.removeItem("SELECTED_DATETIME");

      setModalLoading(true);

      const departmentId =
        selectedDepartment || sessionStorage.getItem("SELECTED_DEPARTMENT_ID") || "";

      if (!departmentId) {
        toast.error("Department not selected.", { position: "top-center" });
        setModalLoading(false);
        return;
      }

      try {

        const response = await fetch(`${config.API_BASE_URL}/GetSingleDayDoctorSchedule`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            dept: departmentId,
            date: dateStr,
            type: hospitalName === "hazra" ? "hazra" : "newtown",
          }),
        });

        const result = await response.json();
        const doctors = result?.data?.["doctor-details"] || [];

        if (result.status === 200 && doctors.length > 0) {
          const doctorsWithExistingAppointments = new Set();

          if (Array.isArray(tableData)) {
            tableData.forEach((appointment) => {
              // ⛔ skip the booking we are currently rescheduling
              if (
                selectedBookingNo &&
                (appointment.BOOKING_NO === selectedBookingNo ||
                  appointment.id === selectedBookingNo)
              ) {
                return;
              }

              let rawDateTime =
                appointment.APPOINTMENT_DATE ||
                appointment.date ||
                appointment.DATE ||
                "";
              if (!rawDateTime) return;

              // get date part only before time
              let onlyDatePart = rawDateTime.split(" ")[0].trim();
              let normalizedDate = "";

              if (onlyDatePart.includes("-")) {
                // DD-MM-YYYY → YYYY-MM-DD
                const [dd, mm, yyyy] = onlyDatePart.split("-");
                normalizedDate = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
              } else if (onlyDatePart.includes("/")) {
                const [dd, mm, yyyy] = onlyDatePart.split("/");
                normalizedDate = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
              }

              const doctorName = (
                appointment.DOCTOR_NAME ||
                appointment.doctor ||
                appointment.DOCTOR ||
                ""
              )
                .trim()
                .toLowerCase();

              // ✅ exclude only if same date + same doctor
              // if (normalizedDate === dateStr && doctorName && tableData.BOOKING_NO === selectedBookingNo) {
              //   doctorsWithExistingAppointments.add(doctorName);
              // }
              const bookingNo = appointment.BOOKING_NO || appointment.id;

              // 🚫 same date + same patient + same doctor → block
              if (
                normalizedDate === dateStr &&
                doctorName &&
                bookingNo === selectedBookingNo
              ) {
                doctorsWithExistingAppointments.add(doctorName);
              }
            });
          }

          // filter API doctors
          const availableDoctors = doctors.filter((doc) => {
            debugger
            const doctorName = (doc.DOCTOR_NAME || doc.DEPT_CODE || "-")
              .trim()
              .toLowerCase();
            return !doctorsWithExistingAppointments.has(doctorName);
          });

          if (availableDoctors.length > 0) {
            const mappedDoctors = availableDoctors.map((doc) => ({
              name: doc.DOCTOR_NAME || doc.DEPT_CODE || "-",
              from: doc.FROM_TIME || "-",
              to: doc.TO_TIME || "-",
              code: doc.DOCTOR_CODE,
              available: doc.AVAILABLE_STATUS === "YES",
            }));

            setModalData({
              date: dateStr,
              doctors: mappedDoctors,
            });
            setIsDoctorListOpen(true);
          } else {
            setModalData(null);
            toast.success("All doctors are already booked for the selected date.", {
              position: "top-center",
              autoClose: 2000,
            });
          }
        } else {
          setModalData(null);
          toast.info("No doctors found for the selected date.", {
            position: "top-center",
            autoClose: 2000,
          });
        }
      } catch (error) {
        setModalData(null);
        toast.error("Network error. Please try again.", {
          position: "top-center",
        });
        console.error("API error:", error);
      } finally {
        setModalLoading(false);
      }
    }
  };

  const getDisabledDatesFromAppointments = (appointments) => {
    const disabledDates = new Set();

    appointments.forEach((appt) => {
      let rawDate = appt.date || "";
      if (!rawDate) return;

      let onlyDate = rawDate.split(" ")[0].trim();
      let normalizedDate = "";

      if (onlyDate.includes("-")) {
        const [dd, mm, yyyy] = onlyDate.split("-");
        normalizedDate = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
      } else if (onlyDate.includes("/")) {
        const [dd, mm, yyyy] = onlyDate.split("/");
        normalizedDate = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
      }

      if (normalizedDate) {
        disabledDates.add(normalizedDate);
      }
    });

    return disabledDates;
  };

  const disabledDates = getDisabledDatesFromAppointments(appointments);









  // Calendar modal close handler
  const handleCalendarModalClose = () => {
    setIsCalendarOpen(false)
    setModalData(null)
    setModalLoading(false)
  }

  // When RESCHEDULE badge is clicked
  const handleRescheduleClick = (bookingNo, dt_code, doctorName) => {
    setSelectedBookingNo(bookingNo)
    setSelectedDepartment(dt_code)
    setSelectedDoctor(doctorName) // store doctor

    setIsCalendarOpen(true)

    getDoctorWeeklySchedule({ dt_code })
      .then((slots) => {
        // Filter slots for THIS doctor only
        const filteredSlots = slots.filter((slot) => slot.doctor === doctorName)

        // Map into FullCalendar events
        const eventsData = filteredSlots.map((slot) => ({
          title: slot.status === "available" ? "Available" : "Not Available",
          start: slot.date,
          allDay: true,
          status: slot.status,
        }))

        setEvents(eventsData)
      })
      .catch((err) => console.error(err))
  }

  const getDoctorWeeklySchedule = async (item) => {
    try {
      setCalendarLoading(true)

      const today = new Date().toISOString().split("T")[0]

      // Generate next 30 days
      const next30 = Array.from({ length: 30 }, (_, i) => {
        const date = new Date()
        date.setDate(date.getDate() + i)
        return date.toISOString().split("T")[0]
      })

      setFutureDates(next30)

      let dt_code = ""

      if (item && typeof item === "object") {
        // Normalize keys
        if (item.dt_code && item.dt_code.trim()) {
          dt_code = item.dt_code.trim()
        } else if (item.DEPARTMENT_CODE && item.DEPARTMENT_CODE.trim()) {
          dt_code = item.DEPARTMENT_CODE.trim()
        } else if (item.department_code && item.department_code.trim()) {
          dt_code = item.department_code.trim()
        }
      }

      if (!dt_code) {
        console.warn("No department code provided to fetch schedule.")
        setCalendarLoading(false)
        return
      }

      const type = hospitalName === "hazra" ? "hazra" : "newtown"

      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/GetDoctorWeeklySchedule`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": tokeng,
        },
        body: JSON.stringify({ dept: dt_code, type }),
      })

      const result = await response.json()

      const available = new Set()
      const unavailable = new Set()
      const dateAvailabilityMap = {}

      const schedule = result?.data?.["weeklySchedule-details"]

      if (result.status === 200 && Array.isArray(schedule)) {
        for (const entry of schedule) {
          const isoDate = toISODate(entry.WEEKDAY_DATE)
          if (!next30.includes(isoDate)) continue

          const isAvailable = entry.AVAILABLE_STATUS === "YES"
          dateAvailabilityMap[isoDate] = dateAvailabilityMap[isoDate] || isAvailable
        }

        for (const date of next30) {
          if (date === today || !dateAvailabilityMap[date]) {
            unavailable.add(date)
          } else {
            available.add(date)
          }
        }
      } else {
        next30.forEach((date) => unavailable.add(date))
      }

      // Ensure today is always unavailable
      available.delete(today)
      unavailable.add(today)

      setDatesWithDoctors(available)
      setDatesWithoutDoctors(unavailable)
      setNaDates([...unavailable])

      const calendarEvents = [
        ...Array.from(available).map((date) => ({
          title: "A",
          start: date,
          display: "background",
          backgroundColor: "#10b981",
          status: "available",
          classNames: ["available"],
        })),
        ...Array.from(unavailable).map((date) => ({
          title: "N/A",
          start: date,
          display: "background",
          backgroundColor: "#ef4444",
          status: "na",
          classNames: ["unavailable-day"],
        })),
      ]

      setEvents(calendarEvents)
    } catch (error) {
      console.error("Error fetching schedule:", error)
      setNaDates([])
      setDatesWithDoctors(new Set())
      setDatesWithoutDoctors(new Set())
    } finally {
      setCalendarLoading(false)
    }
  }


  const handleReshedule = async (doctorCode, fromTime) => {
    const DATE = sessionStorage.getItem("SELECTED_DATE"); // e.g., "2025-08-14"
    const TYPE = sessionStorage.getItem("selectedHospital");

    // Ensure fromTime is in HH:mm:ss format
    const normalizedTime = fromTime.length === 5 ? `${fromTime}:00` : fromTime;

    // Combine DATE and time directly, since DATE is already a string
    const combinedDateTime = `${DATE} ${normalizedTime}`;

    if (!selectedBookingNo || !DATE || !TYPE || !doctorCode) {
      toast.error("Please select a date, doctor, and booking before rescheduling.");
      return;
    }

    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/RESCHEDULE_TBL_ONLINE_BOOKING_PATIENT_MASTER`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": tokeng,
        },
        body: JSON.stringify({
          TYPE,
          BOOKING_NO: selectedBookingNo,
          DOCTOR_CODE: doctorCode,
          DATE: combinedDateTime,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Appointment rescheduled successfully!", {
          autoClose: 2000,
          position: "top-center",
        });

        setTimeout(() => {
          setIsDoctorListOpen(false);
          setIsCalendarOpen(false);
          fetchAppointments();
        }, 3000);
      } else {
        toast.error(`Failed to reschedule: ${data?.message || "Unknown error"}`);
      }
    } catch (error) {
      console.error("Reschedule Error:", error);
      toast.error(`Error: ${error.message}`);
    }
  };



  const handleDoctorSelection = (doctor) => {
    if (!doctor.available) return

    setSelectedDoctorCode(doctor.code) // still updates state for later use
    handleReshedule(doctor.code, doctor.from) // immediately use the selected code
  }

  const matchbookingno = (dateStr) => {
    const matchedAppointment = appointments.find(app => {

      const [dd, mm, yyyy] = app.date.split("-");
      const formattedDate = `${yyyy}-${mm}-${dd}`; // "2026-02-06"

      return (
        formattedDate === dateStr &&
        app.id === selectedBookingNo
      );
    });

    return matchedAppointment ? matchedAppointment.id : null;
  };


  return (
    <>
      <Header />
      {loading ? (
        <FullPageLoader />
      ) : (
        <main className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <div className="container mx-auto px-4 py-2">
            {/* Header Section */}
            <div className="text-center">
              <h3 className="text-2xl md:text-2xl font-bold text-gray-800">
                <i className="fas fa-calendar-check text-blue-500"></i>&nbsp; All Appointments
              </h3>
              <p className="text-gray-600 text-lg">
                Viewing appointments at{" "}
                <span className="font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  {hospitalName === "hazra" ? "CNCI, Hazra in Kolkata" : "CNCI, New Town in Kolkata"}
                </span>
              </p>
            </div>

            {/* Main Content */}
            <div>
              {appointments.length > 0 ? (
                <>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block">
                    <table className="w-full">
                      <thead className=" text-white" style={{ backgroundColor: "#467FCF" }}>
                        <tr>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Sl No
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Booking ID
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Patient
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Doctor
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Department
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Date & Time
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Appointment Status
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Amount
                          </th>
                          <th className="px-4 py-4 text-center text-sm font-semibold uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-gray-100 text-center">
                        {appointments.map((appt, index) => (
                          <tr
                            key={index}
                            className="hover:bg-blue-50 transition-colors duration-200 whitespace-nowrap text-center"
                          >
                            <td className="px-2 py-3 text-xs font-medium text-gray-900 text-center">{index + 1}</td>
                            <td className="px-3 py-3">
                              <span className="font-mono text-s bg-gray-100 px-2 py-1 rounded whitespace-nowrap">
                                {appt.id}
                              </span>
                            </td>
                            <td className="px-3 py-3 text-xs text-gray-900 max-w-[120px] truncate" title={appt.patient}>
                              {appt.patient}
                            </td>
                            <td
                              className="px-3 py-3 text-xs text-gray-900 max-w-[130px] truncate"
                              title={`Dr. ${appt.doctor}`}
                            >
                              Dr. {appt.doctor}
                            </td>
                            <td
                              className="px-3 py-3 text-xs text-gray-600 max-w-[100px] truncate"
                              title={appt.department || "N/A"}
                            >
                              {appt.department || "N/A"}
                            </td>
                            <td className="px-3 py-3 text-xs text-gray-900">
                              <div className="whitespace-nowrap">
                                <div className="font-medium">{appt.date || "N/A"}</div>
                                <div className="text-gray-600">{appt.time || "N/A"}</div>
                              </div>
                            </td>
                            <td className=" text-center">
                              <span
                                className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border whitespace-nowrap 
      ${getStatusColor(appt.status)} 
      ${appt.status === "RESCHEDULE" ? "text-white" : ""}`}
                              >
                                {appt.status === "HOLD_FOR_REFUND"
                                  ? "Cancel in Progress"
                                  : appt.status.replace("_", " ")}
                              </span>

                              {appt.status === "HOLD_FOR_REFUND" && (
                                <p className="text-xs text-muted-foreground m-0">
                                  Please collect your payment from the hospital
                                </p>
                              )}
                            </td>
                            <td className="px-3 py-3 text-sm font-bold text-green-600 whitespace-nowrap">
                              ₹{appt.amount}
                            </td>

                            {appt.status === "HOLD_FOR_REFUND" || appt.status === "CANCELLED" ? (
                              <td className="px-3 py-3">
                                {/* <button
                                  className="flex items-center gap-2 px-3 py-1.5 text-sm text-white bg-gray-400 cursor-not-allowed rounded-md shadow transition duration-150 ml-6"
                                  disabled
                                >
                                  Action
                                  <i className="fa-solid fa-chevron-down transform transition-transform duration-200" />
                                </button> */}
                              </td>
                            ) : (
                              <td className="px-3 py-3">
                                <div className="relative inline-block text-left" data-dropdown>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      toggleDropdown(appt.id)
                                    }}
                                    className="flex items-center gap-2 px-3 py-1.5 text-sm text-white bg-gray-700 hover:bg-gray-800 rounded-md shadow transition duration-150"
                                  >
                                    Action
                                    <i
                                      className={`fa-solid fa-chevron-down transform transition-transform duration-200 ${openDropdownId === appt.id ? "rotate-180" : ""}`}
                                    />
                                  </button>

                                  <div
                                    className={`${openDropdownId === appt.id ? "block" : "hidden"}
          absolute right-0 z-50 mt-2 w-56 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5 border border-gray-100
          ${index >= appointments.length - 2 ? "dropdown-up" : ""}`}
                                    data-dropdown
                                  >
                                    <div className="py-2">
                                      {/* {appt.status === "CONFIRM" && (
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handlePrintOpdBill(appt.pt_code);
                                            closeAllDropdowns();
                                          }}
                                          className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                        >
                                          <i className="fa-solid fa-print text-blue-600 mr-3 w-4"></i>
                                          Print OPD Bill
                                        </button>
                                      )} */}
                                      {appt.online_payment_status === "S" && (
                                        <button
                                          onClick={() => handleDownloadApplication(appt.id)}
                                          disabled={downloadingId === appt.id}
                                          className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50"
                                        >
                                          {downloadingId === appt.id ? (
                                            <>
                                              <svg className="animate-spin h-4 w-4 mr-2" />
                                              Downloading...
                                            </>
                                          ) : (
                                            <>
                                              <TiDocumentText />
                                              &nbsp;Print Receipt
                                            </>
                                          )}
                                        </button>

                                      )}
                                      {appt.status === "RESCHEDULE" && (
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            handleRescheduleClick(appt.id, appt.dt_code)
                                            closeAllDropdowns()
                                          }}
                                          className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                        >
                                          <i className="fa fa-calendar text-blue-600" aria-hidden="true"></i>&nbsp;
                                          Reschedule Appointment
                                        </button>
                                      )}
                                      {canCancelAppointment(appt.date, appt.time) && (
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setSelectedAppointmentId(appt.id)
                                            setShowModal(true)
                                            closeAllDropdowns()
                                          }}
                                          className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
                                        >
                                          <i className="fa-solid fa-trash text-red-600 mr-3 w-4"></i>
                                          Cancel Appointment
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="lg:hidden divide-y px-2">
                    {appointments.map((appt, index) => (
                      <div
                        key={index}
                        className="rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border border-gray-100 mb-2 px-2 py-2"
                      >
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded">
                                #{index + 1}
                              </span>
                              <div
                                className={`inline-flex flex-col items-start px-2 py-1 rounded-md text-xs font-medium border ${getStatusColor(appt.status)}`}
                              >
                                <span>
                                  {appt.status === "HOLD_FOR_REFUND"
                                    ? "Cancel in Progress"
                                    : appt.status.replace("_", " ")}
                                </span>
                                {appt.status === "HOLD_FOR_REFUND" && (
                                  <span className="text-[10px] text-gray-500 ">
                                    Please collect amount from the hospital
                                  </span>
                                )}
                              </div>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-1">{appt.patient}</h3>
                            <p className="text-sm text-gray-600">Dr. {appt.doctor || "-"}</p>
                          </div>
                          <div className="text-right">
                            <div className="text-2xl font-bold text-green-600 mb-1">₹{appt.amount}</div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Booking ID</div>
                            <div className="font-mono bg-gray-100 px-2 py-1 rounded text-xs">{appt.id}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Department</div>
                            <div className="text-gray-900">{appt.department || "N/A"}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Date</div>
                            <div className="text-gray-900 font-medium">{appt.date || "N/A"}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Time</div>
                            <div className="text-gray-900 font-medium">{appt.time || "N/A"}</div>
                          </div>
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3">
                          {appt.status !== "HOLD_FOR_REFUND" && appt.status !== "CANCELLED" && (
                            <div className="relative" data-dropdown>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation()
                                  toggleDropdown(appt.id)
                                }}
                                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-white bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                              >
                                Actions
                                <i className="fas fa-chevron-down text-xs"></i>
                              </button>

                              <div
                                className={`${openDropdownId === appt.id ? "block" : "hidden"
                                  } absolute right-0 z-500 mt-2 w-56 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5 border border-gray-100`}
                                data-dropdown
                              >
                                <div className="py-2">
                                  {/* {appt.status === "CONFIRM" && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handlePrintOpdBill(appt.pt_code);
                                        closeAllDropdowns();
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                    >
                                      <i className="fa-solid fa-print text-blue-600 mr-3 w-4"></i>
                                      Print OPD Bill
                                    </button>
                                  )} */}
                                  {appt.online_payment_status === "S" && (
                                    <button
                                      onClick={() => handleDownloadApplication(appt.id)}
                                      disabled={downloadingId === appt.id}
                                      className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50"
                                    >
                                      {downloadingId === appt.id ? (
                                        <>
                                          <svg className="animate-spin h-4 w-4 mr-2" />
                                          Downloading...
                                        </>
                                      ) : (
                                        <>
                                          <TiDocumentText />
                                          &nbsp;Print Receipt
                                        </>
                                      )}
                                    </button>

                                  )}
                                  {appt.status === "RESCHEDULE" && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleRescheduleClick(appt.id, appt.dt_code, appt.doctor) // pass doctor name/code here
                                        closeAllDropdowns()
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                    >
                                      <i className="fa fa-calendar text-blue-600" aria-hidden="true"></i>&nbsp;
                                      Reschedule Appointment
                                    </button>
                                  )}
                                  {canCancelAppointment(appt.date, appt.time) && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        setSelectedAppointmentId(appt.id)
                                        setShowModal(true)
                                        closeAllDropdowns()
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
                                    >
                                      <i className="fa-solid fa-trash text-red-600 mr-3 w-4"></i>
                                      Cancel Appointment
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="text-center py-20">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
                    <i className="fas fa-calendar-times text-gray-400 text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">No Appointments Found</h3>
                  <p className="text-gray-500">{fetchError || "You don't have any appointments yet."}</p>
                </div>
              )}
            </div>
          </div>

          {/* Cancel Modal */}
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 backdrop-blur-sm p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 relative overflow-hidden">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl transition-colors duration-200 z-10"
                  aria-label="Close cancel modal"
                >
                  <i className="fa-solid fa-times"></i>
                </button>
                <div className="bg-red-500 px-6 py-4">
                  <div className="flex items-center text-white">
                    <div className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 rounded-full mr-3">
                      <i
                        className="fa fa-trash text-red-600 hover:text-red-800 cursor-pointer transition duration-150"
                        aria-hidden="true"
                      ></i>
                    </div>
                    <h2 className="text-xl font-bold text-white">Cancel Appointment</h2>
                  </div>
                </div>
                <div className="p-6">
                  <div className="mb-6">
                    <div className="bg-gray-50 rounded-lg p-4 mb-4">
                      <div className="text-sm text-gray-600 mb-1">Booking ID</div>
                      <div className="font-mono font-bold text-gray-800 text-lg">{selectedAppointmentId}</div>
                    </div>
                    <p className="text-gray-600">Are you sure you want to cancel this appointment?</p>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <button
                      onClick={handleDelete}
                      className="flex-1 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                    >
                      Yes, Cancel Appointment
                    </button>
                    <button
                      onClick={() => setShowModal(false)}
                      className="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg font-semibold transition-all duration-200"
                    >
                      Keep Appointment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Payment Modal */}
          {selectedOrder && bookingAmountInfo && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-white">
                      <div className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 rounded-full mr-3">
                        <i className="fas fa-credit-card text-black text-lg"></i>
                      </div>
                      <h2 className="text-xl font-bold text-white">Complete Payment</h2>
                    </div>
                    <button
                      onClick={closePayNowModal}
                      className="text-blue-200 hover:text-white transition-colors duration-200"
                      aria-label="Close payment modal"
                    >
                      <i className="fas fa-times text-lg"></i>
                    </button>
                  </div>
                </div>

                <div className="p-6">
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-5 mb-6 border border-gray-100">
                    <div className="space-y-4">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Booking No:</span>
                        <span className="font-bold text-gray-800">{bookingAmountInfo.BOOKING_NO}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Mode:</span>
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold ${bookingAmountInfo.DEVELOPMENT_MODE === "YES"
                            ? "bg-yellow-100 text-yellow-800 border border-yellow-200"
                            : "bg-green-100 text-green-800 border-green-200"
                            }`}
                        >
                          {bookingAmountInfo.DEVELOPMENT_MODE === "DEVELOPMENT_MODE" ? "Development" : "Production"}
                        </span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Order ID:</span>
                        <span className="font-mono text-sm bg-white px-2 py-1 rounded border">
                          {bookingAmountInfo.ORDER_ID}
                        </span>
                      </div>
                      <div className="border-t pt-4 mt-4">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-700 font-semibold text-lg">Total Amount:</span>
                          <div className="text-right">
                            <div className="text-3xl font-bold text-green-600">
                              ₹{bookingAmountInfo.REGISTRATION_AMT}
                            </div>
                            <div className="text-sm text-gray-500">Including all charges</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <button
                    onClick={handleProceedToPayment}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 mb-4"
                  >
                    <i className="fas fa-shield-alt mr-2"></i>
                    Pay ₹{Number(bookingAmountInfo.REGISTRATION_AMT).toFixed(2)} Securely
                  </button> */}
                  <button
                    onClick={handleProceedToPayment}
                    disabled={isPaying}
                    className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 mb-4
    ${isPaying
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700"}
  `}
                  >
                    {isPaying ? (
                      <span className="flex items-center justify-center">
                        <span className="animate-spin h-4 w-4 mr-2 border-2 border-white border-t-transparent rounded-full" />
                        Processing...
                      </span>
                    ) : (
                      <>
                        <i className="fas fa-shield-alt mr-2"></i>
                        Pay ₹{Number(bookingAmountInfo.REGISTRATION_AMT).toFixed(2)} Securely
                      </>
                    )}
                  </button>

                  <div className="flex items-center justify-center space-x-4 text-xs text-gray-500 mb-4">
                    <div className="flex items-center">
                      <i className="fas fa-lock mr-1"></i>
                      <span>256-bit SSL</span>
                    </div>
                    <div className="flex items-center">
                      <i className="fas fa-shield-check mr-1"></i>
                      <span>Secure Gateway</span>
                    </div>
                    <div className="flex items-center">
                      <i className="fas fa-credit-card mr-1"></i>
                      <span>PCI Compliant</span>
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 text-center leading-relaxed">
                    Your payment information is encrypted and secure. We accept all major credit cards, debit cards, and
                    UPI payments.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* 🌟 Calendar Modal */}
          <AnimatePresence>
            {isCalendarOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
                onClick={handleCalendarModalClose}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.95, y: 30 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.95, y: 30 }}
                  transition={{ duration: 0.3, type: "spring", stiffness: 200 }}
                  className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl mx-4 p-6 relative max-h-[90vh] overflow-y-auto"
                  onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
                >
                  <button
                    onClick={handleCalendarModalClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl"
                  >
                    <i className="fa-solid fa-times" />
                  </button>

                  <h2 className="text-xl font-semibold mb-4 text-gray-700">
                    📅 Reschedule Appointment

                  </h2>

                  <div className="bg-white rounded-xl border border-gray-200 overflow-hidden min-h-[300px] flex items-center justify-center">
                    {calendarLoading ? (
                      <div className="flex flex-col items-center justify-center py-10 space-y-4">
                        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                        <p className="text-gray-600">Loading available slots...</p>
                      </div>
                    ) : (
                      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden w-full">
                        <style jsx>{`
                .fc {
                  font-family: 'Inter', sans-serif;
                }
                .fc-toolbar {
                  padding: 1rem;
                  background: #467FCF;
                  color: white;
                  border-radius: 0.75rem 0.75rem 0 0;
                }
                .fc-toolbar-title {
                  font-size: 1.25rem !important;
                  font-weight: 700 !important;
                  color: white !important;
                }
                .fc-button {
                  background: rgba(255, 255, 255, 0.2) !important;
                  border: 1px solid rgba(255, 255, 255, 0.3) !important;
                  color: white !important;
                  border-radius: 0.5rem !important;
                  padding: 0.5rem 1rem !important;
                  font-weight: 500 !important;
                  transition: all 0.3s ease !important;
                }
                .fc-button:hover {
                  background: rgba(255, 255, 255, 0.3) !important;
                  transform: translateY(-1px);
                }
                .fc-button:disabled {
                  opacity: 0.5 !important;
                }
                .fc-daygrid-day {
                  position: relative;
                  cursor: pointer;
                  transition: all 0.2s ease;
                }
                .fc-daygrid-day:hover {
                  background-color: #f8fafc !important;
                }
                .fc-daygrid-day-number {
                  padding: 0.5rem;
                  font-weight: 600;
                  color: #374151;
                }
                .fc-day-today .fc-daygrid-day-number {
                  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
                  color: white;
                  border-radius: 50%;
                  width: 2rem;
                  height: 2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0.25rem;
                }
                .fc-event {
                  border-radius: 0.375rem !important;
                  border: none !important;
                  font-size: 0.75rem !important;
                  font-weight: 600 !important;
                  padding: 0.125rem 0.375rem !important;
                  margin: 0.125rem !important;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
                }
                .fc-daygrid-day-frame {
                  min-height: 3rem;
                }
                @media (max-width: 640px) {
                  .fc-toolbar {
                    flex-direction: column;
                    gap: 0.5rem;
                    padding: 0.75rem;
                  }
                  .fc-toolbar-chunk {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 0.5rem;
                  }
                  .fc-toolbar-title {
                    font-size: 1rem !important;
                    text-align: center;
                  }
                  .fc-button {
                    padding: 0.375rem 0.75rem !important;
                    font-size: 0.875rem !important;
                  }
                  .fc-daygrid-day-frame {
                    min-height: 2.5rem;
                  }
                  .fc-daygrid-day-number {
                    padding: 0.25rem;
                    font-size: 0.875rem;
                  }
                  .fc-day-today .fc-daygrid-day-number {
                    width: 1.75rem;
                    height: 1.75rem;
                    font-size: 0.875rem;
                  }
                  .fc-event {
                    font-size: 0.6rem !important;
                    padding: 0.1rem 0.25rem !important;
                  }
                }
              `}</style>

                        <FullCalendar
                          plugins={[dayGridPlugin, interactionPlugin]}
                          initialView="dayGridMonth"
                          weekends={true}
                          events={events.filter((ev) => ev.doctor === selectedDoctor)}
                          dateClick={(info) => {
                            const clickedEvent = events.find(
                              (e) => e.start === info.dateStr && e.doctor === selectedDoctor
                            );

                            if (!clickedEvent || clickedEvent.status !== "available") {
                              return;
                            }

                            // if (disabledDates.has(info.dateStr)) {
                            if (matchbookingno(info.dateStr)) {
                              toast.info("This date is already booked.", {
                                autoClose: 2000,
                                position: "top-center",
                              });
                              return;
                            }


                            handleDateClick(info);
                          }}
                          fixedWeekCount={false}
                          height="auto"
                          headerToolbar={{
                            left: "prev",
                            center: "title",
                            right: "next",
                          }}
                          dayCellClassNames={(arg) => {
                            const classes = ["transition-all", "duration-200"];

                            if (arg.isToday) {
                              classes.push("bg-blue-50");
                            }

                            const dateStr = arg.date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
                            if (disabledDates.has(dateStr)) {
                              classes.push("fc-disabled-date");
                            }

                            return classes;
                          }}

                          eventDidMount={(info) => {
                            const status = info.event.extendedProps.status;
                            const eventDate = new Date(info.event.startStr);

                            // Zero out the time for a reliable date-only comparison
                            eventDate.setHours(0, 0, 0, 0);

                            const today = new Date();
                            today.setHours(0, 0, 0, 0);

                            const sevenDaysLater = new Date(today);
                            sevenDaysLater.setDate(today.getDate() + 7);

                            info.el.style.cursor = status === "available" ? "pointer" : "not-allowed";

                            if (status === "na") {
                              if (eventDate >= today && eventDate <= sevenDaysLater) {
                                // Only color red within 7-day window
                                info.el.style.background = "linear-gradient(135deg, #ef4444, #dc2626)";
                                info.el.style.color = "white";
                              } else {
                                // After 7 days: no red, and optional dimming
                                info.el.style.background = "none";
                                info.el.style.opacity = "0.6";
                              }
                            } else if (status === "available") {
                              info.el.style.background = "linear-gradient(135deg, #10b981, #047857)";
                              info.el.style.color = "white";
                              info.el.addEventListener("mouseenter", () => {
                                info.el.style.transform = "scale(1.05)";
                                info.el.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.4)";
                              });
                              info.el.addEventListener("mouseleave", () => {
                                info.el.style.transform = "scale(1)";
                                info.el.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
                              });
                            }
                          }}

                        />
                      </div>
                    )}
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>


          {/* 🌟 Doctor Availability Modal */}
          <AnimatePresence>
            {isDoctorListOpen && modalData && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 z-50 flex items-center justify-center p-4"
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  backdropFilter: "blur(8px)",
                }}
                onClick={() => setIsDoctorListOpen(false)}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.9, y: 20 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.9, y: 20 }}
                  transition={{ duration: 0.3, type: "spring", stiffness: 300 }}
                  className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Modal Header */}
                  <div className="bg-blue-500 text-white p-4 sm:p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                          <i className="fa fa-calendar text-black text-lg"></i>
                        </div>
                        <div>
                          <h3 className="text-lg sm:text-xl font-bold text-white">Available Doctors</h3>
                          <p className="text-blue-100 text-sm">
                            {modalData?.date &&
                              new Date(modalData.date).toLocaleDateString("en-US", {
                                weekday: "long",
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                              })}
                          </p>
                        </div>
                      </div>
                      <button
                        onClick={() => setIsDoctorListOpen(false)}
                        className="w-6 h-6 rounded-full bg-white bg-opacity-20 flex items-center justify-center hover:bg-opacity-30 transition-colors text-red-500"
                      >
                        <i className="fas fa-times text-lg"></i>
                      </button>
                    </div>
                  </div>

                  {/* Modal Body */}
                  <div className="p-4 sm:p-6 max-h-[60vh] overflow-y-auto">
                    {modalLoading ? (
                      <div className="flex flex-col items-center justify-center py-12 space-y-4">
                        <PulseLoader color="#2563eb" size={12} />
                        <p className="text-gray-600">Loading doctor information...</p>
                      </div>
                    ) : (
                      <div className="space-y-4">
                        <div className="text-center mb-6">
                          <h4 className="text-lg font-semibold text-gray-800 mb-2">Available Doctors</h4>
                          <p className="text-gray-600 text-sm">Select a doctor to book your appointment</p>
                        </div>

                        {/* Mobile View */}
                        <div className="block sm:hidden space-y-4">
                          {modalData?.doctors?.length > 0 ? (
                            modalData.doctors.map((doctor, index) => (
                              <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1 }}
                                className={`p-4 rounded-xl border-2 transition-all duration-200 ${doctor.available
                                  ? "border-emerald-200 bg-emerald-50 hover:border-emerald-300 hover:shadow-md"
                                  : "border-gray-200 bg-gray-50"
                                  }`}
                              >
                                <div className="flex items-center justify-between mb-3">
                                  <div className="flex items-center space-x-2">
                                    <div
                                      className={`w-3 h-3 rounded-full ${doctor.available ? "bg-emerald-500" : "bg-gray-400"}`}
                                    ></div>
                                    <h5 className="font-semibold text-gray-800">Dr. {doctor.name}</h5>
                                  </div>
                                  <span
                                    className={`px-2 py-1 text-xs font-medium rounded-full ${doctor.available ? "bg-emerald-100 text-emerald-800" : "bg-gray-100 text-gray-600"
                                      }`}
                                  >
                                    {doctor.available ? "Available" : "Unavailable"}
                                  </span>
                                </div>

                                <div className="flex items-center justify-between mb-4">
                                  <div className="flex space-x-4 text-sm text-gray-600">
                                    <div className="flex items-center space-x-1">
                                      <i className="fas fa-clock text-emerald-500"></i>
                                      <span>{doctor.from}</span>
                                    </div>
                                    <div className="flex items-center space-x-1">
                                      <i className="fas fa-clock text-red-500"></i>
                                      <span>{doctor.to}</span>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  onClick={() => {
                                    if (doctor.available) {
                                      handleRescheduleClick(
                                        modalData.bookingNo, // assuming bookingNo is passed in modalData
                                        modalData.dt_code,
                                        doctor.name,
                                      )
                                      setIsDoctorListOpen(false) // close modal
                                    }
                                  }}
                                  className={`inline-flex items-center space-x-2 px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${doctor.available
                                    ? "bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700 transform hover:scale-105 shadow-lg hover:shadow-xl"
                                    : "bg-gray-200 text-gray-500 cursor-not-allowed"
                                    }`}
                                  disabled={!doctor.available}
                                >
                                  {doctor.available ? (
                                    <>
                                      <i className="fas fa-check-circle"></i>
                                      <span>Book Now</span>
                                    </>
                                  ) : (
                                    <>
                                      <i className="fas fa-ban"></i>
                                      <span>Unavailable</span>
                                    </>
                                  )}
                                </button>
                              </motion.div>
                            ))
                          ) : (
                            <div className="text-center py-8">
                              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                <i className="fas fa-user-md text-2xl text-gray-400"></i>
                              </div>
                              <p className="text-gray-600">No doctors found for this date.</p>
                            </div>
                          )}
                        </div>

                        {/* Desktop View */}
                        <div className="hidden sm:block">
                          <div className="overflow-hidden rounded-xl border border-gray-200">
                            <table className="w-full">
                              <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                                <tr>
                                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 border-r border-gray-200">
                                    <div className="flex items-center space-x-2">
                                      <i className="fas fa-user-md text-blue-500"></i>
                                      <span>Doctor Name</span>
                                    </div>
                                  </th>
                                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 border-r border-gray-200">
                                    <div className="flex items-center space-x-2">
                                      <i className="fas fa-clock text-emerald-500"></i>
                                      <span>From Time</span>
                                    </div>
                                  </th>
                                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 border-r border-gray-200">
                                    <div className="flex items-center space-x-2">
                                      <i className="fas fa-clock text-red-500"></i>
                                      <span>To Time</span>
                                    </div>
                                  </th>
                                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700">
                                    <div className="flex items-center justify-center space-x-2">
                                      <i className="fas fa-calendar-plus text-indigo-500"></i>
                                      <span>Book Appointment</span>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                {modalData?.doctors?.length > 0 ? (
                                  (() => {
                                    let lastDoctorName = null

                                    return modalData.doctors.map((doctor, index) => {
                                      const isDuplicate = doctor.name === lastDoctorName
                                      lastDoctorName = doctor.name

                                      if (isDuplicate) return null // Skip rendering if name is same as last one

                                      return (
                                        <tr
                                          key={index}
                                          className={`border-t border-gray-200 hover:bg-gray-50 transition-colors ${!doctor.available ? "opacity-60" : ""}`}
                                        >
                                          <td className="px-6 py-4 border-r border-gray-200">
                                            <div className="flex items-center space-x-3">
                                              <div
                                                className={`w-3 h-3 rounded-full ${doctor.available ? "bg-emerald-500" : "bg-gray-400"}`}
                                              ></div>
                                              <div>
                                                <div className="font-semibold text-gray-900">Dr. {doctor.name}</div>
                                                <div className="text-sm text-gray-500">
                                                  {doctor.available ? "Available for booking" : "Currently unavailable"}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td className="px-6 py-4 border-r border-gray-200">
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-emerald-100 text-emerald-800">
                                              {doctor.from}
                                            </span>
                                          </td>
                                          <td className="px-6 py-4 border-r border-gray-200">
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800">
                                              {doctor.to}
                                            </span>
                                          </td>
                                          <td className="px-6 py-4 text-center">
                                            <button
                                              className={`inline-flex items-center space-x-2 px-6 py-3 rounded-xl font-semibold transition-all duration-200 ${doctor.available
                                                ? "bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700 transform hover:scale-105 shadow-lg hover:shadow-xl"
                                                : "bg-gray-200 text-gray-500 cursor-not-allowed"
                                                }`}
                                              disabled={!doctor.available}
                                            >
                                              {doctor.available ? (
                                                <>
                                                  <i className="fas fa-check-circle"></i>
                                                  <span onClick={() => handleDoctorSelection(doctor)}>Book Now</span>
                                                </>
                                              ) : (
                                                <>
                                                  <i className="fas fa-ban"></i>
                                                  <span>Unavailable</span>
                                                </>
                                              )}
                                            </button>
                                          </td>
                                        </tr>
                                      )
                                    })
                                  })()
                                ) : (
                                  <tr>
                                    <td colSpan="4" className="px-6 py-12 text-center">
                                      <div className="flex flex-col items-center space-y-4">
                                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                                          <i className="fas fa-user-md text-2xl text-gray-400"></i>
                                        </div>
                                        <div>
                                          <h4 className="text-lg font-semibold text-gray-700 mb-2">
                                            No Doctors Available
                                          </h4>
                                          <p className="text-gray-500">Please try a different date.</p>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Modal Footer */}
                  <div className="bg-gray-50 px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
                    <button
                      onClick={() => setIsDoctorListOpen(false)}
                      className="w-full sm:w-auto inline-flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-700 text-white font-semibold rounded-xl hover:from-gray-700 hover:to-gray-800 transition-all duration-200 transform hover:scale-105"
                    >
                      <i className="fas fa-times"></i>
                      <span>Close</span>
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

        </main>
      )}
      <Footer />
    </>
  )
}
